import create from 'zustand'

export const useHelpCenterStore = create((set) => ({
    selectedQuestion: null, // Stores the selected question title & description

    setSelectedQuestion: (question) => set({ selectedQuestion: question })
}))
